(function () {
    'use strict';

    angular
        .module('app')
        .controller('newFeatureTipController', newFeatureTipController);

    newFeatureTipController.$inject = ['$scope', '$state', 'dialog', '$http'];

    function newFeatureTipController($scope, $state, dialog, $http) {
        var vm = this;
        vm.close = close;
        vm.show = false;

        vm.$onInit = function () {
            if(localStorage.getItem(vm.name) == 'true') {
                vm.show = false;
            } else {
                vm.show = true;
            }
        }

        function close() {
            vm.show = 0;
            localStorage.setItem(vm.name, 'true')
        }

    }
})();